export interface GiroCodeParams {
  bic?: string;
  accountHolder: string;
  iban: string;
  amount: number;
  invoiceNumber: string;
}

/**
 * Erzeugt den normierten Text-Payload für den SEPA-EPC-QR-Code (GiroCode).
 * Standard: EPC069-12 / Version 002
 */
export function generateEpcQrPayload(params: GiroCodeParams): string {
  const cleanIban = params.iban.replace(/\s+/g, '').toUpperCase();
  const cleanBic = (params.bic || '').replace(/\s+/g, '').toUpperCase();
  const holder = params.accountHolder.trim().slice(0, 70);
  const amountFormatted = `EUR${params.amount.toFixed(2)}`;
  const referenceText = `Rechnung ${params.invoiceNumber}`.trim().slice(0, 140);

  if (!cleanIban || !holder || params.amount <= 0) {
    return '';
  }

  // Format:
  // BCD (Service Tag)
  // 002 (Version)
  // 1 (Character Set: UTF-8)
  // SCT (Identification: SEPA Credit Transfer)
  // BIC
  // Name des Empfängers
  // IBAN
  // Betrag
  // Purpose (leer)
  // Remittance Reference (leer)
  // Remittance Information (Verwendungszweck)
  return [
    'BCD',
    '002',
    '1',
    'SCT',
    cleanBic,
    holder,
    cleanIban,
    amountFormatted,
    '',
    '',
    referenceText,
  ].join('\n');
}
